const resource = 'addresses'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  update(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  delete(id, params) {
    return $axios.$delete(`/${resource}/${id}`, { params })
  },

  fetchAccountAddresses() {
    return $axios.$get('/v2/account/addresses')
  },

  getServiceName: name => 'addressService',
})
